import styled from 'styled-components'

export const DashboardContainer = styled.div`
  padding: 20px;
  background: #f6f7fb;
  min-height: 100vh;
`

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 10px;
`

export const SearchInput = styled.input`
  width: 350px;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  outline: none;
  font-size: 14px;

  &:focus {
    border-color: #5b6cff;
  }
`
export const SearchButton = styled.button`
  background: #111827;
  color: white;
  border: none;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: #000;
  }
`

export const CardsWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
`

export const GpsCard = styled.div<{ active?: boolean }>`
  flex: 1;
  background: #ffffff;
  padding: 20px;
  border-radius: 12px;
  border: ${({ active }) => (active ? '3px solid #3b82f6' : '2px solid #e6e8f0')};
  box-shadow: 0 2px 6px rgba(0,0,0,0.04);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #3b82f6;
  }
`

export const HighlightCard = styled.div`
  flex: 1;
  background: #ffffff;
  padding: 20px;
  border-radius: 12px;
  border: 2px solid #5b6cff;
  box-shadow: 0 2px 6px rgba(0,0,0,0.04);
`

export const CardTitle = styled.div`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 6px;
`

// export const CardValue = styled.div`
//   font-size: 28px;
//   font-weight: 600;
//   color: #111827;
// `

export const CardValue = styled.div`
  font-size: 28px;
  font-weight: 600;
  color: #111827;
  cursor: pointer;

  &:hover {
    color: #5b6cff;
  }
`

export const CardSubtitle = styled.div`
  font-size: 12px;
  color: #9ca3af;
  margin-top: 4px;
`

export const TableSection = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e6e8f0;
`

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const TableTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
`

export const TableActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const FilterSelect = styled.select`
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  font-size: 14px;
  cursor: pointer;

  &:focus {
    border-color: #5b6cff;
  }
`

export const ExportButton = styled.button`
  background: #22c55e;
  color: #fff;
  border: none;
  padding: 9px 14px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: #16a34a;
  }
`

export const StatusBadge = styled.span`
  background: #eef2ff;
  color: #4f46e5;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
`

export const ActionButton = styled.button`
  background: #374151;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    background: #111827;
  }
`

export const ResetButton = styled.button`
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 9px 14px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: #e5e7eb;
  }
`